








































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class SubscriptionView extends Vue {
  public items: Common.BatchSchedule[] = new Array(0);
  public params: Common.BatchScheduleQuery = new Common.BatchScheduleQuery();
  public sortOptions: any = [
    { value: 'id', text: 'バッチID' },
    { value: 'queryTypeName', text: 'バッチ処理' },
    { value: 'name', text: 'バッチ名称' },
    { value: 'lastLaunchTime', text: '最終起動時刻' },
    { value: 'nextLaunchTime', text: '次回起動時刻' },
  ];

  public executeNow(item: Common.BatchSchedule){
    this.$api.modal.showDialog('確認',String.format('「{0}」を開始してよろしいですか？',item.name)).then(()=>{
      //カタログ側から呼び出されるバッチクエリをクライアント側から呼び出す=>非同期対応
      this.$api.execute(new Common.BatchLaunchQuery(item.id)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);              
      });
    });

  }
}
